import { BaseService, RequestType, ResponseType } from "@intech/react-service";

class Log extends BaseService {

  constructor() {
    super("Log");
  }

  CriarLog = (numFuncionalidade: number) =>
    this.CreateRequest<string>(RequestType.GET, `CriarLog/${numFuncionalidade}`);

}

export const LogService = new Log();